module.exports = "/_next/static/resources/single-b5cea45ff9632afdb3dffce690d3f758.webp";